import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { StyledEngineProvider } from '@mui/material';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Client, Provider, fetchExchange } from 'urql';

import { AppContextProvider, FacilityContextProvider, TAGThemeProvider } from '@shared-components-web';
import type { TAGBrand as SharedTAGBrand } from '@shared-components-web/types';
import { VirtualPageViewTracker } from '@src/components/shared/third-party/analytics-gtm';
import { LOCAL_VETSPIRE_URL } from '@src/constants';

const client = new Client({
	url: LOCAL_VETSPIRE_URL,
	exchanges: [fetchExchange],
	requestPolicy: 'network-only',
});

export const ContextProviders = ({ config, preview, environment, children, user }) => {
	const router = useRouter();
	const brandTheme = config?.themeId || process.env.TAG_BRAND_THEME || 'lovet';
	const sharedBrandName = brandTheme as SharedTAGBrand;
	const facilityBrandName = brandTheme as SharedTAGBrand;
	const [isClient, setIsClient] = useState(false);

	useEffect(() => {
		setIsClient(true);
	}, []);

	return (
		<Provider value={client}>
			<ContentfulLivePreviewProvider
				locale={router.locale || 'en-US'}
				enableInspectorMode={preview}
				enableLiveUpdates={preview}
			>
				<AppContextProvider
					config={config}
					theme={sharedBrandName}
					environment={environment}
					appName={process.env.APP_NAME || 'tag_dev'}
					appVersion={`${process.env.APP_VERSION || 'unknown'}(design-system:${
						process.env.DESIGN_SYSTEM_VERSION
					})`}
				>
					<StyledEngineProvider injectFirst>
						<TAGThemeProvider branding={sharedBrandName}>
							{isClient && (
								<FacilityContextProvider brand={facilityBrandName as any} user={user}>
									<VirtualPageViewTracker />
									{children}
								</FacilityContextProvider>
							)}
						</TAGThemeProvider>
					</StyledEngineProvider>
				</AppContextProvider>
			</ContentfulLivePreviewProvider>
		</Provider>
	);
};
